export default __webpack_public_path__ + "static/media/Snd_q2.244e024a.mp3";